import { FilterConfigWithValue, FilterValue } from '../types/filter.types';

export const extractFilterValue = <T>(item: FilterValue<T>) => item.value;

export const extractFilterValues = <T>(
  items?: FilterConfigWithValue<FilterValue<T>[]> | FilterValue<FilterValue<T>[]>,
) => {
  if (items && Array.isArray(items.value)) {
    return items?.value.map(extractFilterValue);
  }
  return [];
};

export const prepareMultipleValueIds = <T extends { id: number | string }>(items?: T[]) => {
  if (items && Array.isArray(items) && items.length > 0) {
    return items.map((item) => {
      return { value: item.id };
    });
  }
  return null;
};
